const Spec = () => {
    return (
        <section id='spec text-base'>
            <div className='my-40 text-white relative overflow-clip'>
                <div className='container max-w-[1000px] mx-auto flex flex-row justify-center my-20 md:my-40 space-x-2 relative items-center px-4'>
                    <table className='text-white decoration-none table-auto border-separate [border-spacing:0_0.8rem]'>
                        <tbody>
                            <tr>
                                <th className='bg-stone-800 md:py-4 p-4 md:px-8 md:text-base md:md:min-w-[300px]'>
                                    Title
                                </th>
                                <td className='text-white text-left pl-4 font-medium md:text-base'>
                                    R-Type Tactics I • II Cosmos
                                </td>
                            </tr>
                            <tr>
                                <th className='bg-stone-800 md:py-4 p-4  md:px-8 md:text-base md:min-w-[300px]'>
                                    Platform
                                </th>
                                <td className='text-white text-left pl-4 font-medium md:text-base'>
                                 Physical & Digital:  Nintendo Switch&trade;, PlayStation&reg;4, PlayStation&reg;5 <br /> Digital Only: Nintendo Switch&trade;2,  Xbox Series X|S, PC (Steam / GOG / EGS)  
                                </td>
                            </tr>
                            <tr>
                                <th className='bg-stone-800  md:py-4 p-4 md:px-8 md:text-base md:min-w-[300px]'>
                                    Genre
                                </th>
                                <td className='text-white text-left pl-4 font-medium md:text-base'>
                                    Turn-based Strategy
                                </td>
                            </tr>
                            <tr>
                                <th className='bg-stone-800  md:py-4 p-4 md:px-8 md:text-base md:min-w-[300px]'>
                                    Player(s)
                                </th>
                                <td className='text-white text-left pl-4 font-medium md:text-base'>1</td>
                            </tr>
                            <tr>
                                <th className='bg-stone-800  md:py-4 p-4  md:px-8 md:text-base  md:min-w-[300px]'>
                                    Text Languages
                                </th>
                                <td className='text-white text-left pl-4 py-4 font-medium md:text-base max-w-[500px]'>
                                    English, French, Italian, German, Spanish, Japanese, Chinese (Simplified and
                                    Traditional) and Korean
                                </td>
                            </tr>
                            <tr>
                                <th className='bg-stone-800 md:py-4 p-4  md:px-8 md:text-base  md:min-w-[300px]'>
                                    Voice Language
                                </th>
                                <td className='text-white text-left pl-4 font-medium md:text-base'>
                                English and Japanese
                                </td>
                            </tr>
                            <tr>
                                <th className='bg-stone-800 md:py-4 p-4 md:px-8 md:text-base  md:min-w-[300px]'>
                                   Release
                                </th>
                                <td className='text-white text-left pl-4 font-medium md:text-base'> June 18, 2026</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </section>
    )
}

export default Spec
